import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import DeviceDetailsTable from "./DeviceDetailsTable";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import DeviceDetailsTableHeader from "./DeviceDetailsTableHeader";
import PaginationManager from "../../view/PaginationManager";
import * as changelogService from "../deviceChangelogService";
import * as deviceService from "../deviceService";

function DeviceDetailsDataTableSection({ deviceId }) {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        isLoading: true
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    const getDeviceChangelogPage = async (pageNumber, pageSize) => {
        const device = await deviceService.loadDeviceById(deviceId);
        const msbId = device.msb.id;
        return changelogService.listPageable(pageNumber, pageSize, deviceId, msbId)
    }

    //const getDeviceChangelogPage = async (pageNumber, pageSize) => changelogService.listPageable(pageNumber, pageSize, deviceId)

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <DeviceDetailsTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <DeviceDetailsTable />
                                            <PaginationManager
                                                getPage={getDeviceChangelogPage} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default DeviceDetailsDataTableSection;
